import { ReserveListDetailOut } from '../../../../store/api';
import { reservesConfig } from '../../../../config';
import { http } from '../../../../api/axios';

export function fetchReserveSummary(reserveListId: string) {
    return http
        .get<ReserveListDetailOut>(reservesConfig().endpointReserveSummary, {
            pathParams: {
                reserveListId
            }
        })
        .then(response => response.data);
}
